import { Api } from '../api';
import { registration } from '../endpoints';
import type { ApiResponse } from '../../models';
import type {
  RegisterCompleteRequest,
  RegisterRequest,
  RegisterResponse,
  ResendCodeResponse,
  SignupRequest,
  SignupResponse,
  VerifyRequest,
  VerifyResponse,
} from './models';
import { AuthUtils } from '@shared/utils';

export class RegistrationApi extends Api {
  static signup = (request: SignupRequest) => this.post<SignupRequest, ApiResponse<SignupResponse>>({ url: registration.signup(), data: request });

  // PERSONAL
  static register = (data: RegisterRequest) =>
    this.post<RegisterRequest, ApiResponse<RegisterResponse>>({ url: registration.register(), data, withAuthError: true });
  static verify = (data: VerifyRequest) =>
    this.post<VerifyRequest, ApiResponse<VerifyResponse>>({
      url: registration.verify(),
      data,
      headers: { Authorization: `Bearer ${AuthUtils.resendCodeToken || AuthUtils.registerToken}` },
      withAuthError: true,
    });
  static resendCode = () =>
    this.post<null, ApiResponse<ResendCodeResponse>>({
      url: registration.resendCode(),
      headers: { Authorization: `Bearer ${AuthUtils.registerToken}` },
      withAuthError: true,
    });
  static registerComplete = (data: RegisterCompleteRequest) =>
    this.post<RegisterCompleteRequest, ApiResponse<undefined>>({
      url: registration.registerComplete(),
      data,
      headers: { Authorization: `Bearer ${AuthUtils.verifyToken}` },
      withAuthError: true,
    });
}
